<div class="chip mr-2" *ngIf="attributeFilter.value !== null && attributeFilter.value !== undefined">
  <span [innerHTML]="attributeFilter.htmlButtonText()"></span>
  <jhi-bary-icon icon="times" [faDirective]="FAS" class="text-danger close" (click)="removeButton()"></jhi-bary-icon>
</div>
